export default __webpack_public_path__ + "static/media/100_39020.5a714f72.jpg";